// extracted by mini-css-extract-plugin
export default {"navigationContainer":"Navigation_navigationContainer__3n2AC","navigationMessage":"Navigation_navigationMessage__c8eQa"};